import moment from "moment";
import { useSearchDebtorTotalsQuery } from "../../../services/headofficeadmin";
import { useAdministrationFeesProvider } from "../../../hooks/AdministrationFeesContext";

const useDebtorTotals = (searchType) => {
    const { filters, currentSearchType } = useAdministrationFeesProvider();
    //setFilters(DebtorManagementDefaultFilters);
    //const { filters } = useAdministrationFeesProvider();
    //console.log('filtersNow', filters);

    //console.log('debtors totals filters ',filters);

    const { data, isLoading, isFetching, isError, error, refetch } = useSearchDebtorTotalsQuery({
        searchType:currentSearchType,
        filter:{
        ...filters,
        adviserIds: filters.advisers?.map(x => x.value) ?? [],
        masterAccountIds: filters.masterAccounts?.map(x => x.value) ?? [],
        providerIds: filters.providers?.map(x => x.value) ?? [],
        debtOnDate: filters.debtOnDate ?? moment().format('YYYY/MM/DD'),
    }});

    const retryGetDebtorTotals = (e) => {
        if (e && typeof (e.preventDefault) === "function") {
            e.preventDefault();
        }
        refetch();
    }

    return {
        data,
        isFetching,
        isLoading,
        isError,
        error,
        retryGetDebtorTotals
    }
};
export default useDebtorTotals;